import React from 'react';

import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { uiActions } from '../../store/slices/uiSlice';

const AUTO_DISMISS_MS = 4000;

const typeColors: Record<string, { background: string; color: string }> = {
  error: { background: 'var(--tg-theme-destructive-text-color, #e53935)', color: '#fff' },
  success: { background: '#43a047', color: '#fff' },
  info: { background: 'var(--tg-theme-accent-text-color, #1976d2)', color: '#fff' },
};

export function TavernToast() {
  const dispatch = useAppDispatch();
  const notification = useAppSelector((s) => s.ui.notification);

  React.useEffect(() => {
    if (!notification) return;

    const timer = setTimeout(() => {
      dispatch(uiActions.clearNotification());
    }, AUTO_DISMISS_MS);

    return () => clearTimeout(timer);
  }, [dispatch, notification]);

  if (!notification) return null;

  const colors = typeColors[notification.type] ?? typeColors.info;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        minHeight: 'var(--notification-height, 44px)',
        zIndex: 'var(--z-notification, 400)' as unknown as number,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '8px 16px',
        fontSize: '14px',
        fontWeight: 500,
        textAlign: 'center',
        ...colors,
      }}
      role="alert"
    >
      {notification.message}
    </div>
  );
}
